export const de = {
    store: "Geschäft",
    meal: "Mahlzeit",
    users: "Benutzer",
    user: "Benutzer",
    layout: "Layout",
    analytics: "Analytik",
    settings: "Einstellungen",
    storeDetails: "Geschäftsdetails",
    advanced: "Erweitert",
    name: "Name",
    quantity: "Menge",
    address: "Adresse",
    email: "E-Mail",
    phone: "Telefon",
    galleryForCustomer: "Galerie/Werbung für Kundenbildschirm",
    customMealCategory: "Benutzerdefinierte Mahlzeitenkategorie",
    storeType: "Geschäftstyp",
    currency: "Währung",
    add: "Hinzufügen",
    print: "Drucken",
    sessions: "Sitzungen",
    orders: "Bestellungen",
    customerFacingScreen: "Kundensichtschirm",
    cashierView: "Kassensicht",
    kitchenView: "Küchensicht",
    layoutView: "Layoutansicht",
    history: "Geschichte",
    noOrderRecordsExist: "Keine Bestellungsdatensätze vorhanden",
    noSessionRecordsExist: "Keine Sitzungsdatensätze vorhanden",
    updateMenu: "Menü aktualisieren",
    updateMenuSuccessfully: "Menü erfolgreich aktualisiert",
    updateMenuTooltip: "Laden Sie das neueste Menü auf den Server hoch, nach jeder Änderung an Ihren Mahlzeiten",
    serving: "Bedienung",
    active: "Aktiv",
    inactive: "Inaktiv",
    amount: "Betrag",
    total: "Gesamt",
    table: "Tisch",
    payment: "Zahlung",
    changeDue: "Rückgeld",
    printReceipt: "Quittung drucken",
    cancel: "Abbrechen",
    complete: "Vollständig",
    edit: "Bearbeiten",
    delete: "Löschen",
    update: "Aktualisieren",
    deleteOrder: "Bestellung löschen",
    printOrderSlip: "Bestellzettel drucken",
    printKitchenSlip: "Küchenzettel drucken",
    latestOrderAt: "Letzte Bestellung um",
    completedAt: "Abgeschlossen um",
    received: "Erhalten",
    startEditing: "Beginnen Sie mit der Bearbeitung",
    save: "Speichern",
    addSmallDiningTable: "Kleinen Speisetisch hinzufügen",
    addMediumDiningTable: "Mittleren Speisetisch hinzufügen",
    addLargeDiningTable: "Großen Speisetisch hinzufügen",
    clearAll: "Alles löschen",
    undo: "Rückgängig machen",
    reorder: "Neu ordnen",
    renew: "Erneuern",
    renewSession: "Sitzung erneuern",
    createNewSession: "Neue Sitzung erstellen",
    addSession: "Sitzung hinzufügen",
    createSession: "Sitzung erstellen",
    printSession: "QR-Code drucken",
    takeOrder: "Bestellung aufnehmen",
    editOrder: "Bestellung bearbeiten",
    completeOrder: "Bestellung abschließen",
    description: "Beschreibung",
    ingredients: "Zutaten",
    price: "Preis",
    category: "Kategorie",
    createdDate: "Erstellungsdatum",
    lastUpdated: "Zuletzt aktualisiert",
    lastUpdatedAt: "Zuletzt aktualisiert um",
    admins: "Administratoren",
    members: "Mitglieder",
    invited: "Eingeladen",
    owner: "Eigentümer",
    member: "Mitglied",
    admin: "Administrator",
    adminsTooltip: "Nur der Super-Administrator (Geschäftsinhaber) kann die Admin-Rolle vergeben und entfernen",
    membersTooltip: "Mitglied darf nur Bestellungen von Kunden ansehen und verwalten",
    invitedTooltip: "Eingeladene Personen erhalten die [Mitglied]-Rolle, sobald die Einladung akzeptiert wird",
    invitedPeople: "Eingeladene Personen",
    transferOwnership: "Eigentum übertragen",
    removeAdminRole: "Admin-Rolle entfernen",
    grantAdminRole: "Admin-Rolle vergeben",
    invitePeople: "Personen einladen",
    addStore: "Geschäft hinzufügen",
    alreadyExists: "existiert bereits",
    existingInvitationTo: "Bestehende Einladung an",
    emailIsRequired: "E-Mail ist erforderlich",
    nameIsRequired: "Name ist erforderlich",
    priceIsRequired: "Preis ist erforderlich",
    invalidEmailAddress: "Ungültige E-Mail-Adresse",
    fullService: "Vollservice",
    limitedService: "Begrenzter Service",
    storeTypeDescription: "Die Änderung des Geschäftstyps beeinflusst die Anzeige und Bearbeitung jeder Bestellung an der Kasse",
    limitedServiceDescription: "Begrenzter Service verwaltet Bestellungen als eine Bestellung pro Einreichung (z. B. Imbissstand, Food Court)",
    fullServiceDescription: "Vollservice verwaltet Bestellungen als eine Bestellung pro Tisch/Sitzung (z. B. Restaurant, Café)",
    fullServiceExplain: "Vollservice bietet ein vollständiges Speiseerlebnis und Kunden zahlen üblicherweise nach dem Essen (z. B. Restaurant, Café)",
    limitedServiceExplain: "Begrenzter Service beendet üblicherweise die Kundeninteraktion (Bedienung & Zahlung) vor/nach dem Essen (z. B. Imbissstand, Food Court)",
    orderIsEmpty: "Bestellung ist leer",
    completedByKitchen: "Von der Küche abgeschlossen",
    changeMealImage: "Mahlzeitenbild ändern",
    uploadMealImage: "Mahlzeitenbild hochladen",
    food: "Essen",
    drink: "Getränk",
    side: "Beilage",
    submitted: "Eingereicht",
    confirmDeleteMeal: "Löschen der Mahlzeit bestätigen?",
    confirmRenewSession: "Sitzung ist noch gültig, Erneuerung bestätigen?",
    confirmCompleteOrder: "Vollständige Bestellung bestätigen?",
    confirmDeleteSession: "Löschen der Sitzung bestätigen?",
    confirmDeleteImage: "Löschen des Bildes bestätigen?",
    storeInvitation: "Geschäftseinladung",
    noInvitationFound: "Keine Einladung gefunden, bitte fordern Sie eine Berechtigung vom Geschäftsadministrator an",
    join: "Beitreten",
    joinStore: "Geschäft beitreten",
    settingUpStore: "Ihr Geschäft einrichten",
    createStore: "Geschäft erstellen",
    invitation: "Einladung",
    uploadProfilePicture: "Profilbild hochladen",
    changeProfilePicture: "Profilbild ändern",
    myStores: "Meine Geschäfte",
    profile: "Profil",
    accountSettings: "Kontoeinstellungen",
    signOut: "Abmelden",
    deleteStore: "Geschäft löschen",
    cloneStore: "Geschäft klonen",
    uploadImage: "Bild hochladen",
    temporarySession: "Vorübergehende Sitzung (wird innerhalb von 24 Stunden ablaufen)",
    deleteSessionOnCompletion: "Sitzung nach Bestellabschluss löschen",
    autoRenew: "Sitzung nach Bestellabschluss automatisch erneuern (Löschen der Sitzung erforderlich)",
    limitedServiceSession: "Sitzungsauslauf und -löschung wurden deaktiviert, um den Betrieb mit begrenztem Service anzupassen, Sie können Ihre bevorzugten Sitzungseinstellungen unten konfigurieren",
    noExistingNameFound: "Erstellen Sie hier eine Sitzung und dann einen Tisch unter",
    ifYouWantLink: ", um Sitzung und Tisch in der Layoutansicht zu verknüpfen",
    noOptions: "Keine Optionen",
    addCustomerGallery: "Bildschirmwerbung/Galerie hinzufügen",
    grantAdminRoleToast: "wurde die [Admin]-Rolle erteilt",
    removeAdminRoleToast: "wurde in die Mitgliederliste verschoben",
    deleteInvitationToast: "wurde von der Einladungsliste entfernt",
    deleteMemberToast: "wurde von der Mitgliederliste entfernt",
    deleteAdminToast: "wurde von der Administratorenliste entfernt",
    transferOwnershipToast: "Geschäftseigentum übertragen an",
    sendInvitationToast: "Einladung erfolgreich gesendet an",
    switchedStoreToast: "Gewechselt zu",
    deleteStoreToast: "Erfolgreich gelöscht",
    recommendItToCustomer: "Dem Kunden empfehlen",
    emailUs: "E-Mailen Sie uns für Anfragen",
    emailUsShort: "E-Mail",
    signup: "Anmelden",
    login: "Einloggen",
    quitStore: "Geschäft verlassen",
    switchToStore: "Zu Geschäft wechseln",
    changeLogo: "Logo ändern",
    uploadLogo: "Logo hochladen",
    emailVerifiedToast: "Ihre E-Mail wurde verifiziert!",
    emailSentToast: "E-Mail gesendet!",
    emailSentToastDescription: "Bitte überprüfen Sie Ihre E-Mail zur Verifizierung",
    emailVerificationErrorToast: "Verifizierungs-E-Mail bereits gesendet",
    emailVerificationFailedToast: "Fehler beim Senden der Verifizierungs-E-Mail",
    resetPasswordToast: "Danke, überprüfen Sie Ihre E-Mail für Anweisungen zum Zurücksetzen Ihres Passworts",
    emailNotExist: "E-Mail existiert nicht",
    failedToUpload: "Hochladen fehlgeschlagen",
    saveLayoutToast: "Tischlayout wurde aktualisiert",
    invalidEmailOrPassword: "Ungültige E-Mail oder Passwort",
    failedToLogin: "Anmeldung fehlgeschlagen",
    verificationEmailSent: "E-Mail verifizieren",
    verificationEmailSentDescription: "Um Ihren Registrierungsprozess abzuschließen, müssen wir überprüfen, dass die E-Mail-Adresse Ihnen gehört.",
    emailAlreadyExist: "E-Mail existiert bereits",
    successfullyCreateStore: "Geschäft erfolgreich erstellt",
    pleaseSwitchStore: ", bitte wechseln Sie zu Ihrem neuen Geschäft.",
    pleaseCreateMeal: ", bitte fahren Sie fort, Mahlzeiten für Ihr Geschäft zu erstellen.",
    youAreNowMemberOf: "Sie sind jetzt Mitglied von",
    orderFromTable: "Bestellung vom Tisch",
    isCompleted: "ist abgeschlossen",
    addedCategory: "Kategorie hinzugefügt",
    removedCategory: "Kategorie entfernt",
    currencyChanged: "Währung geändert zu",
    successfullyUpdateStore: "Geschäft erfolgreich aktualisiert",
    storeTypeChanged: "Geschäftstyp geändert zu",
    layoutNotReady: "Layout nicht bereit...",
    layoutNotReadyDescription: "Sie haben Ihr Layout noch nicht erstellt, bitte fahren Sie fort, ein Layout für Ihr Geschäft zu erstellen.",
    createLayout: "Layout erstellen",
    confirmQuitStore: "Geschäft verlassen bestätigen?",
    minimumItemQuantity: "Minimale Dezimalzahl der Bestellmenge",
    noMoreOrder: "Keine weiteren Bestellungen",
    loadMore: "Mehr laden",
    id: "ID",
    notifications: "Benachrichtigungen",
    noNotificationFound: "Keine Benachrichtigung gefunden",
    allowMemberEdit: "Mitgliedern erlauben, Bestellungen zu bearbeiten",
    storeCreated: "Geschäft erstellt",
    storeCreatedNotification: "Sie haben Ihr Geschäft erfolgreich eingerichtet, bitte fahren Sie fort, Mahlzeiten für Ihr Geschäft zu erstellen.",
    manageSubscription: "Abonnement verwalten",
    billing: "Abrechnung",
    currentSubscription: "Aktuelles Abonnement",
    mySubscription: "Mein Abonnement",
    initiateSubscription: "Wenn Sie Geschäftsinhaber sind, bitte erstellen Sie zuerst ein Geschäft.",
    selectYourStoreType: "Wählen Sie Ihren Geschäftstyp",
    configureStoreTypeInfo: "Geschäftstyp kann später neu konfiguriert werden, wenn Sie sich nicht sicher sind, welchen Sie wählen sollen.",
    compulsoryItem: "Automatisch hinzugefügt und unveränderliche Menge",
    compulsory: "Obligatorisch",
    yes: "Ja",
    no: "Nein",
    hiddenFromMenu: "Im Menü versteckt",
    dashboard: "Armaturenbrett",
    addedPaymentMethod: "Zahlungsmethode hinzugefügt",
    removedPaymentMethod: "Zahlungsmethode entfernt",
    paymentMethod: "Zahlungsmethode",
    paymentMethods: "Zahlungsmethoden",
    options: "Optionen",
    summarized: "Zusammengefasst",
    unit: "Einheit",
    unitPlaceHolder: "Einheit zu Anzeigezwecken (z.B. Gramm, kg, Sets)",
    totalAmount: "Gesamtbetrag",
    checkout: "Kasse",
    back: "Zurück",
    close: "Schließen",
    remark: "Bemerkung",
    orderSettings: "Bestelleinstellungen",
    paymentKitchenOrder: "Zuerst servieren / Zuerst bezahlen",
    paymentFirst: "Zuerst bezahlen",
    servedFirst: "Zuerst servieren",
    alwaysCompleteAtKitchenView: "Für die Operation 'Zuerst bezahlen' vervollständigen Sie Ihre Bestellung immer in der Küchensicht, nachdem bezahlt wurde.",
    paymentFirstWarning: "Die Auswahl von 'Zuerst bezahlen' für Vollservice kann unerwartetes Verhalten verursachen",
    paymentKitchenExplained: "Wählen Sie nur die Option 'Zuerst bezahlen', um zu verhindern, dass die Bestellung nach der Bezahlung entfernt wird. Dies ist nützlich, wenn Ihr Personal Informationen in der Küchensicht lesen muss (z.B. Zutaten)",
    tableName: "Sitzungs-/Layouttischname",
    storeOperation: "Geschäftsbetrieb",
    sessionControl: "Sitzungssteuerung",
    all: "Alle",
    simple: "Einfach",
    sessionControlExplained: "Mit der [Einfachen] Sitzungssteuerung können Sie [Neue Sitzung hinzufügen], [Sitzung löschen], [Sitzung erneuern] und [Sitzung drucken] in [Kassensicht] nicht durchführen, also bitte richten Sie Ihre Sitzungskonfiguration richtig ein, bevor Sie zur [Einfachen] Sitzungssteuerung wechseln.",
    none: "Keine",
    nearest: "Nächstgelegene",
    up: "Oben",
    down: "Unten",
    roundingTotal: "Gesamtpreis runden",
    roundingItem: "Artikelpreis runden",
    changeTo: "Geändert zu",
    allSessionControl: "Vollständige Sitzungssteuerung",
    simpleSessionControl: "Einfache Sitzungssteuerung",
    requiredTableName: "Personal/Kunden bitten, beim Bezahlen den Tischnamen einzugeben (nicht bezogen auf den Layouttisch)",
    pleaseInsertTableName: "Bitte geben Sie Ihren Tischnamen ein",
    session: "Sitzung",
    inheritFromStore: "Vom Geschäft übernommen",
    customerScreen: "Kundenbildschirm",
    recentOrders: "Neueste Bestellungen",
    standard: "Standard",
    standardMenuControl: "Standard-Menüsteuerung",
    simpleMenuControl: "Einfache Menüsteuerung",
    menuControl: "Personalmenü",
    completePaymentFirstAlert: "Bitte vervollständigen Sie die Zahlung zuerst in [Kassensicht]",
    detail: "Detail",
    detailNotExists: "Bestelldetail existiert nicht mehr",
    addedRemarkShortcut: "Bemerkungsshortcut hinzugefügt",
    removedRemarkShortcut: "Bemerkungsshortcut entfernt",
    remarkShortcuts: "Bemerkungsshortcuts",
    paymentMethodNameIsRequired: "Name der Zahlungsmethode ist erforderlich",
    paymentMethodAlreadyExisted: "Zahlungsmethode existierte bereits",
    categoryNameIsRequired: "Kategoriename ist erforderlich",
    categoryAlreadyExisted: "Kategorie existierte bereits",
    shortcutNameIsRequired: "Name des Shortcuts ist erforderlich",
    shortcutAlreadyExisted: "Shortcut existierte bereits",
    shortcut: "Shortcut",
    createOption: "Option erstellen",
    optionName: "Optionsname",
    requireChange: "Wechselgeldberechnung bei Zahlung erforderlich",
    menuSettings: "Menüeinstellungen",
    paymentSettings: "Zahlungseinstellungen",
    submittingOrder: "Bestellung wird eingereicht...",
    submittedOrder: "Bestellung erfolgreich eingereicht!",
    addMeal: "Mahlzeit hinzufügen",
    createdFirstMeal: "Erste Mahlzeit erstellen",
    pleaseUpdateMenu: "Sie haben erfolgreich Ihre erste Mahlzeit erstellt, bitte klicken Sie hier, um Ihr Menü zu aktualisieren, nachdem Sie Ihre Mahlzeiten vollständig eingerichtet haben.",
    pleaseCreateSession: "Bitte fahren Sie fort zu [Kassensicht], um Ihre erste Sitzung/Tisch zu erstellen.",
    storeSetupComplete: "Einrichtung des Geschäfts erfolgreich",
    moreStoreConfiguration: "Drücken Sie auf den QR-Code, um mit der Bestellung zu beginnen, oder drucken Sie den QR-Code für Ihre Kunden, um Bestellungen aufzunehmen. Fahren Sie fort zum [Einstellungen]-Bereich, um spezifischere Geschäftskonfigurationen zu aktualisieren, um Ihren Geschäftsbetrieb perfekt anzupassen.",
    ok: "Okay",
    features: "Funktionen",
    others: "Andere",
    kitchen: "Küchensicht",
    hasBeen: "wurde",
    enabled: "aktiviert",
    disabled: "deaktiviert",
    untickToDisable: "Abwählen, um Funktion zu deaktivieren",
    printAfterCompletion: "Drucken nach Bestellabschluss",
    userDecide: "Benutzer entscheidet",
    alreadyAMember: "Bereits Mitglied?",
    sign_up: "Anmelden",
    log_in: "Einloggen",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordMustBe6: "Passwort muss mindestens 6 Zeichen lang sein",
    required: "Erforderlich",
    passwordUnmatched: "Passwort stimmt nicht überein",
    forgotPassword: "Passwort vergessen?",
    OR: "ODER",
    signInWithGoogle: "Mit Google anmelden",
    forgotPasswordInfo: "Sie erhalten eine E-Mail mit einem Zurücksetzungslink",
    resetPassword: "Passwort zurücksetzen",
    verifyYourEmail: "Überprüfen Sie Ihre E-Mail-Adresse",
    check: "Überprüfen",
    toVerify: "um Ihr Konto zu verifizieren und zu starten.",
    ifYouHaveNotReceived: "Wenn Sie die E-Mail nach einigen Minuten nicht erhalten haben, überprüfen Sie bitte Ihren Spam-Ordner",
    resendVerificationEmail: "Verifizierungs-E-Mail erneut senden",
    refresh: "Aktualisieren",
    startNow: "Jetzt starten",
    freeUnlimitedUsers: "Kostenlos. Unbegrenzte Benutzer.",
    etilhubDescription: "Eine leichte POS-Lösung, um Ihr Restaurant und F&B-Geschäft effizient zu betreiben.",
    cloudSmart: "Cloud-basiert | Smart",
    pointOfSale: "Verkaufsstelle",
    registerForFree: "Kostenlos registrieren",
    qrFoodOrdering: "QR Essen Bestellung",
    contactlessOrders: "Kontaktlose Bestellungen",
    instantAndEasySetup: "Sofortige und einfache Einrichtung",
    adjustableForEveryBusiness: "Anpassbar für jedes F&B-Geschäftsmodell",
    billingProcessingPrinting: "Abrechnungsverarbeitung & Drucken",
    orderSlipPrinting: "Bestellzetteldruck",
    issueReceipt: "Ausstellen von gedruckten oder elektronischen Quittungen",
    sessionQRPrinting: "Drucken von Sitzungs-QR-Codes",
    instantKitchenView: "Sofortige Küchensicht",
    realtimeOrderStatus: "Echtzeit-Bestellstatus",
    orderQueue: "Bestellwarteschlange",
    ingredientsDisplay: "Zutatenanzeige",
    customizableFloorPlan: "Anpassbarer Grundriss",
    restaurantTableLayout: "Restauranttischlayout",
    realtimeTableStatus: "Echtzeit-Tischstatus",
    intuitiveInterface: "Intuitive Schnittstelle",
    moreFeatures: "Weitere Funktionen",
    comingsoon: "Demnächst...",
    noItemExist: "Keine Artikel vorhanden",
    myStore: "Mein Geschäft",
    logout: "Abmelden",
    navigationSettings: "Navigationseinstellungen",
    navigateToPaymentAfterSubmit: "Nach Bestellungseinreichung zur Zahlung navigieren (Kassensicht)",
    size: "Größe",
    small: "Klein",
    medium: "Mittel",
    large: "Groß",
    tableNameMustBeSame: "Der Tischname muss mit dem Sitzungsnamen übereinstimmen, Sie können hier zuerst einen Tisch erstellen, bevor Sie fortfahren, eine Sitzung für Ihr Geschäft zu erstellen.",
    confirmDeleteStore: "Bestätigen Sie, dass Sie dieses Geschäft löschen möchten, indem Sie dessen Namen eingeben:",
    deleteThisStore: "Dieses Geschäft löschen?",
    deleteStoreWarning: "Dadurch wird das Geschäft dauerhaft entfernt und kann nicht wiederhergestellt werden.",
    pleaseInsertStoreName: "Bitte geben Sie den Geschäftsnamen ein",
    cloneThisStore: "Dieses Geschäft klonen",
    cloneStoreInfo: "Aktualisieren Sie die Details für Ihr neues Geschäft.",
    addIngredient: "Zutat hinzufügen",
    orderUpdatedAt: "Bestellung aktualisiert am Tisch",
    simpleMenuInfo: "Hinweis: Einfaches Menü hat eine Begrenzung bei der Auswahl mehrerer Optionen für jede Mahlzeit.",
    fiverr: "Fiverr",
    bySigningUp: "Durch die Anmeldung stimmen Sie unseren",
    privacyPolicy: "Datenschutzrichtlinien",
    termsAndConditions: "Geschäftsbedingungen",
    and: "und",
    storeExceedSubscriptionLimit: "Anzahl der Geschäfte überschreitet das Abonnementlimit, aktualisieren Sie Ihren Plan, um mehr Geschäfte hinzuzufügen.",
    someStoreIsNotShowing: "Einige Geschäfte werden aufgrund des Ablaufs Ihres Abonnements nicht angezeigt.",
    currentPeriodStart: "Aktueller Zeitraum beginnt",
    currentPeriodEnd: "Ihr Plan wird erneuert am",
    planCanceledOn: "Ihr Plan wird gekündigt am",
    storeQuantity: "Geschäftsmenge",
    dailyOrder: "Tägliches Bestelllimit",
    perStore: "pro Geschäft",
    createdBy: "Erstellt von",
    completedBy: "Abgeschlossen von",
    monday: "Montag",
    tuesday: "Dienstag",
    wednesday: "Mittwoch",
    thursday: "Donnerstag",
    friday: "Freitag",
    saturday: "Samstag",
    sunday: "Sonntag",
    morePrices: "Mehr Preise in Optionen",
    moreIngredients: "Mehr Zutaten in Optionen",
    all_: "Alle",
    filter: "Filter",
    expired: "Abgelaufen",
    updated: "Aktualisiert",
    limitTime: "Zeitlimit",
    limitDay: "Tageslimit",
    outOfStock: "Nicht auf Lager",
    startFrom: "Beginnt von",
    endAt: "Endet um",
    hour: "Stunde",
    hours: "Stunden",
    default: "Standard",
    cloud: "Wolke",
    printMethod: "Druckmethode",
    sessionCreated: "Sitzung erstellt",
    orderCreated: "Bestellung erstellt",
    event: "Ereignis",
    eventDescription: "Alle Druckknöpfe (z. B. Sitzung drucken, Bestellzettel drucken, Küchenzettel drucken, Quittung drucken) lösen standardmäßig das Webhook-Ereignis aus. Wählen Sie zusätzliche Ereignistypen aus, um Webhooks auszulösen",
    endPointDescription: "Geben Sie die URL ein, an der Sie die Webhooks erhalten möchten",
    webhookDescription: "Wir senden eine POST-Anfrage an diese URL mit einem JSON-Objekt, das die Ereignisdaten für alle Ereignisse darstellt, die Sie auslösen möchten",
    testEndpointUrl: "Endpunkt-URL testen",
    failedToPrint: "Druck fehlgeschlagen",
    secretKeyDescription: "Geheimcode wird verwendet, um mit dem HTTP-Körper mit HMAC-SHA256 zu signieren und ist im Header namens X-Hub-Signature enthalten",
    outGoingWebhooks: "Ausgehende Webhooks",
    urlIsRequired: "URL ist erforderlich",
    invalidUrl: "Ungültige URL",
    endpointUrl: "Endpunkt-URL",
    addWebhook: "Webhook hinzufügen",
    confirmDeleteWebhook: "Webhook löschen bestätigen?",
    printButtonClick: "Küche",
    takeOrderforTable: "Bestellung",
    addGuestNumber: "Gästenummer hinzufügen",
    customerScreen: "Kundenbildschirm",
    orderHistory: "Bestellverlauf",
    endSession: "Sitzung beenden",
    orderNow: "Jetzt bestellen",
    viewMenu: "Menü anzeigen",
    adults: "Erwachsene",
    kids: "Kinder",
    seniors: "Senioren",
    other: "Andere",
    all: "Alle",
    leaveWarning: "Sind Sie sicher, dass Sie gehen möchten? Änderungen, die Sie vorgenommen haben, werden möglicherweise nicht gespeichert.",
    personAtTable: "Personen bestellen am Tisch",
    bePatient: "Bitte haben Sie Geduld.",
    checkMenu: "Bitte überprüfen Sie das Menü.",
    categoryDeleted: "Kategorie gelöscht",
    categorySuccessfullyDeleted: "Kategorie erfolgreich gelöscht",
    errorDeletingCategory: "Fehler beim Löschen der Kategorie",
    anErrorOccurred: "Ein Fehler ist aufgetreten",
    cloneItem: "Artikel klonen",
    language: "Sprache",
    itemPrintName: "Druckname des Artikels",
    serviceFee: "Servicegebühr",
    salesReport: "Verkaufsbericht",
    chatPrint: "Chat-Druck",
    send: "Senden",
    openChatPrint: "Chat-Druck öffnen",
    deleteCategory: "Kategorie löschen",
    deleteCategoryConfirmation: "Löschung der Kategorie bestätigen",
    categoryName: "Kategoriename",
    deleteCategoryWarning: "Möchten Sie diese Kategorie wirklich löschen?",
    cannotDeleteCategoryWithItems: "Kategorie kann nicht gelöscht werden, da sie Artikel enthält",
    totalItems: "Gesamtartikel",
    itemsInCategory: "Artikel in der Kategorie",
    pleaseRemoveItemsFirst: "Bitte entfernen Sie zuerst die Artikel",
    deletionFailed: "Löschen fehlgeschlagen",
    transferOwnershipToast: "Eigentum wurde übertragen",
    verificationEmailSentDescription: "Eine Bestätigungs-E-Mail wurde gesendet",
    transferOwnership: "Eigentum übertragen",
    verificationEmailSentDescription: "Eine Bestätigungs-E-Mail wurde gesendet",
    categoryAll: "Alle",
    languageSettings: "Spracheinstellungen",
    selectLanguagePopupInfo: "Bitte wählen Sie die Sprache, die im Start-Popup angezeigt werden soll, aber Sie müssen die Sprache jedes im System hochgeladenen Gerichts abrufen.",
    languagePopupEnabled: "Sprach-Popup aktivieren",
    languageChoiceActive: "Sprachauswahl aktiv",
    selectLanguage: "Sprache auswählen",
    languageChoiceUpdated: "Sprachauswahl aktualisiert auf",
    untickToDisable: "Deaktivieren durch Abwählen",
    loadingSession: "Sitzung wird geladen...",
    sessionInvalid: "Sitzung ungültig",
    loadingMenu: "Menü wird geladen...",
    loadingSession: "Sitzung wird geladen...",
    sessionInvalid: "Sitzung ungültig",
    loadingMenu: "Menü wird geladen...",
    mergeTables: "Tische Zusammenführen",
    selectTablesToMerge: "Tische zum Zusammenführen Auswählen",
    selectedTables: "Ausgewählte Tische",
    primary: "Primär",
    active: "Aktiv",
    cannotRemove: "Kann nicht Entfernt Werden",
    primaryTableRequired: "Haupttisch kann nicht entfernt werden",
    add: "Hinzufügen",
    applyMerge: "Zusammenführung Anwenden",
    invalidTables: "Ungültige Tische",
    noActiveOrders: "haben keine aktiven Bestellungen",
    enterYourName: "Geben Sie Ihren Namen ein",
    continue: "Fortfahren",
    othersOrdering: "Tisch ist offen. Willkommen zum Beitreten!",
    nameRequired: "Name erforderlich",
    pleaseEnterName: "Bitte geben Sie Ihren Namen ein, um fortzufahren",
    error: "Fehler",
    somethingWentWrong: "Etwas ist schiefgelaufen",
    welcomeBack: "Willkommen zurück",
    pleaseWait: "Bitte warten",
    sessionCheckInProgress: "Sitzungsprüfung läuft",
    noSuchTable: "Entschuldigung, dieser Tisch existiert nicht!",
    waitingForStaff: "Warten auf Personal, um den Tisch für Sie zu öffnen ...",
    scanQRCodeAgain: "Bitte scannen Sie den QR-Code erneut, um zu bestellen oder auf das Menü zuzugreifen!",
    bonAppetit: "Guten Appetit!",
    modalSelectLanguage: "Sprache auswählen",
    sessionNotProvided: "Keine Sitzung bereitgestellt",
    noStoreIdProvided: "Keine Store-ID in der Sitzung",
    storeNotConfigured: "Geschäft nicht gefunden",
    failedToLoadData: "Fehler beim Laden der Daten",
    orderNumber: "Bestellung #",
    orderCreated: "Erstellt",
    orderTotal: "Bestellsumme",
    totalWithTaxes: "Gesamtsumme mit Steuern",
    customerName: "Name",
    totalFor: "Gesamt für",
    noOrders: "Keine Bestellungen",
    grandTotal: "Gesamtsumme",
    pastOrders: "Vergangene Bestellungen",
    poweredBy: "Unterstützt von",
    closeButton: "Schließen",
    thisSelectionIsRequired: "Diese Auswahl ist erforderlich",
    pleaseSelectAtLeast: "Bitte wählen Sie mindestens",
    maximumSelections: "Maximal",
    selectionsAllowed: "Auswahlen erlaubt",
    optionItems: "Optionen",
    customizeYourOrder: "Passen Sie Ihre Bestellung an",
    totalExtra: "Zusätzliche Kosten",
    cancelButton: "Abbrechen",
    addToCart: "In den Warenkorb",
    selectExactly: "Sie müssen genau",
    singleItem: "Element",
    selectRange: "Wählen Sie",
    rangeTo: "bis",
    selectAtLeast: "Wählen Sie mindestens",
    selectUpTo: "Wählen Sie bis zu",
    selectMultipleOptional: "Mehrfachauswahl (Optional)",
    selectOneRequired: "Eine Auswahl (Erforderlich)",
    requiredOption: "Erforderlich",
    
    // TableRedirect translations
    invalidStoreId: "Ungültige Geschäfts-ID",
    tableRedirectStoreNotFound: "Geschäft nicht gefunden",
    tableRedirectError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    loadingTable: "Suche nach Ihrem Tisch...",
    fixedTableQrDisabled: "Feste Tisch-QR-Codes sind für dieses Geschäft deaktiviert.",
    contactStaffForHelp: "Bitte kontaktieren Sie das Personal für Hilfe"
};